import { render, staticRenderFns } from "./HorizontalCard.vue?vue&type=template&id=d6b93676&scoped=true"
import script from "./HorizontalCard.vue?vue&type=script&lang=js"
export * from "./HorizontalCard.vue?vue&type=script&lang=js"
import style0 from "./HorizontalCard.vue?vue&type=style&index=0&id=d6b93676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b93676",
  null
  
)

export default component.exports